import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV3';
import { DateRangePicker as MuiDateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { parseISO } from 'date-fns';
import styles from './dateRangePicker.style';

const DateRangePicker = ({
  value,
  onChange,
  startText = 'Start Date',
  endText = 'End Date',
  format = 'dd/MM/yyyy',
  size = 'small',
  width = '120px',
  error,
  ...props
}) => {
  const handleChange = (newValue) => {
    if (onChange) {
      onChange(newValue);
    }
  };

  // Convert ISO string dates back to date objects for display, but allow Date objects too
  const toDate = (d) => {
    if (!d) return null;
    if (typeof d === 'string') return parseISO(d);
    if (d instanceof Date) return d;
    return null;
  };
  const convertedValue = [toDate(value?.[0]), toDate(value?.[1])];

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MuiDateRangePicker
        localeText={{
          start: startText,
          end: endText,
        }}
        format={format}
        value={convertedValue}
        onChange={handleChange}
        slotProps={{
          textField: {
            size,
            error: !!error,
            sx: {
              width,
              ...styles.textfield,
            },
          },
          actionBar: {
            actions: ['clear'],
          },
          popper: {
            sx: styles.popper,
          },
        }}
        sx={styles.dateRangeContainer}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default DateRangePicker;
